export function getWindowHostname(): string {
    if (typeof window === 'undefined' || !window.location?.hostname) {
        return '';
    }
    return window.location.hostname;
}

export function getWindowHost(): string {
    if (typeof window === 'undefined' || !window.location?.host) {
        return '';
    }
    return window.location.host;
}

export function getWindowOrigin(): string {
    if (typeof window === 'undefined' || !window.location?.origin) {
        return '';
    }
    return window.location.origin;
}

export function readLocalStorage(key: string, fallback = ''): string {
    if (typeof localStorage === 'undefined') {
        return fallback;
    }
    return localStorage.getItem(key) || fallback;
}

export function writeLocalStorage(key: string, value: string): void {
    if (typeof localStorage === 'undefined') {
        return;
    }
    localStorage.setItem(key, value);
}

export function readLocalStorageJson<T>(key: string, fallback: T | null = null): T | null {
    const raw = readLocalStorage(key, '');
    if (!raw) {
        return fallback;
    }
    try {
        return JSON.parse(raw) as T;
    } catch {
        return fallback;
    }
}

export function isBrowser(): boolean {
    return typeof window !== 'undefined';
}

export function extractRequestHostname(request: {
    headers: Record<string, string | string[] | undefined>;
} | null): string {
    if (!request) {
        return '';
    }

    const hostHeader = request.headers['x-forwarded-host'] || request.headers.host;
    const host = Array.isArray(hostHeader) ? hostHeader[0] : hostHeader;
    if (!host) {
        return '';
    }

    return host.split(':')[0];
}
